import { render, staticRenderFns } from "./storeDtl.vue?vue&type=template&id=fc457a70&scoped=true"
import script from "./storeDtl.vue?vue&type=script&lang=js"
export * from "./storeDtl.vue?vue&type=script&lang=js"
import style0 from "./storeDtl.vue?vue&type=style&index=0&id=fc457a70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc457a70",
  null
  
)

export default component.exports